<div class="messages-page">
  <div class="chat-message-position">
    @for (enabledChat of enabledChats; track enabledChat; let i = $index) {
      <div [id]="'drawer-' + enabledChat.id">
        <app-chat-drawer
          [chatRoom]="enabledChat"
          [messagesToRender]="enabledChatsMessages[i]"
          [source]="source"
          (closeChat)="closeChat($event)"
          (sendMessage)="sendMessage($event)"
          (saveDraftMessage)="saveDraftMessage($event)"
          (toggleCollapse)="toggleCollapse($event)"
          (getMoreMessages)="getMoreMessages($event)"
        >
        </app-chat-drawer>
      </div>
    }
    @if (selectNewChatOpen$ | async) {
      <app-chat-drawer-new
        [suppliers]="selectSuppliers$ | async"
        (openChat)="openChat($event)"
        (closeChat)="closeNewChat($event)"
      >
      </app-chat-drawer-new>
    }
  </div>
</div>
